"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function AbstractElement(_ref) {
  var children = _ref.children,
      tagName = _ref.tagName,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "tagName"]);
  var Tag = tagName;
  return _react.default.createElement(Tag, rest, children);
}

AbstractElement.propTypes = {
  children: _propTypes.default.node,
  tagName: _propTypes.default.string.isRequired
};
AbstractElement.defaultProps = {
  tagName: 'span'
};
AbstractElement.displayName = 'AbstractElement';
var _default = AbstractElement;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/elements/AbstractElement.js
// module id = 355
// module chunks = 209 210 211 212